import { h } from 'preact'
import { useMemo } from 'preact/hooks'
import classNames from 'clsx'

import { buildTagPermalink } from '../../../utils/urls'
import LinkWrapper from '../../atom/link-wrapper'

import styles from './index.module.scss'

const TagCloud = (props) => {
  const { className, entries = [], ...rest } = props

  const parsed = useMemo(() => {
    if (!entries.length) {
      return null
    }

    const max = entries.reduce((memo, entry) => {
      return entry.count > memo ? entry.count : memo
    }, 0)

    const min = entries.reduce((memo, entry) => {
      return entry.count < memo ? entry.count : memo
    }, 0)

    return entries
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(entry => ({
        ...entry,
        size: Math.floor((entry.count - min) / (max - min) * 10),
      }))
  }, [entries])

  if (!entries.length) {
    return null
  }

  return (
    <ul className={buildClassNames({ className })} {...rest}>
      {parsed.map(({ id, slug, name, size, className }) => (
        <li
          data-size={size}
          key={id}
          className={buildEntryClassNames({
            size,
            className,
          })}
        >
          <LinkWrapper href={buildTagPermalink({ slug })}>
            {name}
          </LinkWrapper>
        </li>
      ))}
    </ul>
  )
}

function buildClassNames({ className }) {
  return classNames(
    className,
    styles['m-tag-cloud'],
  )
}

function buildEntryClassNames({ className, size = 0 }) {
  return classNames(
    className,
    styles['m-tag-cloud__entry'],
    styles[`m-tag-cloud__entry--size-${size}`],
  )
}

export default TagCloud
